import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-loading',
  imports: [ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './loading.component.html',
  styles: ``
})
export class LoadingComponent {
  @Input() size: number = 64;
  @Input() color: string = 'border-primary';
  @Input() borderWidth: number = 4;
  @Input() text?: string;
}

